import { setByPath } from "../../../../Routes/RenderPdf/dataPaths";

export function setValueAtPath(state, payload) {
  if (!payload || payload.path == null) return {};
  let updatedData = {
  }
  if (state.reportType === "trend") {
    return {
      trendData: setByPath(state.trendData, payload.path, payload.value),
      trendDirty: true
    }
  }
  else {
    return {
      data: setByPath(state.data, payload.path, payload.value),
      dirty: true,
    };
  }

}


export const changeRenderType = (state, payload) => {
  return {
    reportType: payload.reportType
  }
}